module.exports = __webpack_public_path__ + "static/media/intel_e5@2x.c2ccc435.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gear/workstation/intel_e5@2x.png
// module id = 317
// module chunks = 0